import { Paper } from '@mui/material';
import Footer from 'components/footer/Footer';
import AccountMenu from 'components/navbar/AccountMenu';
import Sidebar from 'components/sidebar/Sidebar';
import UserGeoAccessBanner from 'components/UserGeoAccessBanner';

import { useSidebar } from 'hooks/UseSideBar';
import React from 'react';
import { RequireAuth, useAuthUser } from 'react-auth-kit';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import routes from 'routes.js';

export default function AdminLayout(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState('Statistiques');
  const { isCollapsed } = useSidebar();

  React.useEffect(() => {
    window.addEventListener('resize', () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);
  React.useEffect(() => {
    getActiveRoute(routes);
  }, [location.pathname]);

  const getActiveRoute = (routes) => {
    let activeRoute = 'Statistiques';
    for (let i = 0; i < routes.length; i++) {
      if (window.location.href.indexOf(routes[i].layout + '/' + routes[i].path) !== -1) {
        setCurrentRoute(routes[i].name);
      }
    }
    return activeRoute;
  };

  const auth = useAuthUser();
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === '/admin') {
        return (
          auth()?.user?.roles?.filter((role) => prop?.roles?.includes(role?.name)).length > 0 && (
            <Route
              path={`/${prop.path}`}
              // element={prop.component}
              element={<RequireAuth loginPath={'/auth/sign-in'}>{prop.component}</RequireAuth>}
              key={key}
            />
          )
        );
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = 'ltr';
  return (
    <div
      className="flex h-full w-full"
      style={{
        backgroundImage: 'url(/assets/img/image2.jpeg)',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        height: '100dvh',
      }}
    >
      <div
        className="flex h-full w-full "
        style={{
          backdropFilter: 'blur(3px)',

          height: '100dvh',
        }}
      >
        <Paper
          className={'flex flex-col items-between content-between'}
          sx={{
            width: isCollapsed ? 'var(--sidebar-width-collapsed)' : 'var(--sidebar-width-expanded)',
            minWidth: isCollapsed
              ? 'var(--sidebar-width-collapsed)'
              : 'var(--sidebar-width-expanded)',
            maxWidth: isCollapsed
              ? 'var(--sidebar-width-collapsed)'
              : 'var(--sidebar-width-expanded)',
            transition:
              'width 280ms cubic-bezier(0.4, 0, 0.2, 1), min-width 280ms cubic-bezier(0.4, 0, 0.2, 1), max-width 280ms cubic-bezier(0.4, 0, 0.2, 1)',
            overflow: 'hidden',
            flexShrink: 0,
          }}
        >
          <div style={{ height: '100%', overflow: 'auto' }}>
            <Sidebar open={open} onClose={() => setOpen(false)} />
          </div>
          <div className="bg-gray-100 mt-auto">
            <Footer />
          </div>
        </Paper>

        {/* Navbar & Main Content */}
        <div className="flex flex-col h-full w-full bg-lightPrimary dark:!bg-navy-900">
          {/* Main Content */}
          <main
            className="main-wrapper"
            // className={`mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[200px]`}
          >
            {/* Routes */}
            <div className="h-full p-0">
              <AccountMenu />

              <div className="mx-auto mb-auto h-full min-h-[84vh] px-2">
                <UserGeoAccessBanner />
                <Routes>
                  {getRoutes(routes)}
                  <Route path="/" element={<Navigate to="/admin/default" replace />} />
                </Routes>
              </div>
            </div>
          </main>
          {/* <div className="">
          <p className="text-red-500">lololo</p>
          <Footer />
        </div> */}
        </div>
      </div>
    </div>
  );
}
